import React, { Suspense, lazy } from 'react';

import AccountListSkeleton from '@components/Account/Skeleton/AccountListSkeleton';
import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const AccountList = lazy(() => import('@components/Account/AccountList'));

/** 홈 > 계정 정보 관리 */
const Account = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<AccountListSkeleton />}>
          <AccountList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Account;
